interface IconProps {
  className?: string;
  color?: string;
}

// Chercheur - Microscope
export function ChercheurIcon({ className = "w-12 h-12", color = "#D8B4FE" }: IconProps) {
  return (
    <svg viewBox="0 0 100 100" className={className} xmlns="http://www.w3.org/2000/svg">
      {/* Base du microscope */}
      <rect x="35" y="75" width="30" height="8" fill={color} opacity="0.15" rx="2" />
      <rect x="35" y="75" width="30" height="8" fill="none" stroke={color} strokeWidth="2.5" rx="2" />

      {/* Corps du microscope */}
      <rect x="42" y="50" width="16" height="25" fill={color} opacity="0.15" rx="2" />
      <rect x="42" y="50" width="16" height="25" fill="none" stroke={color} strokeWidth="2.5" rx="2" />

      {/* Oculaire */}
      <circle cx="50" cy="42" r="6" fill="white" stroke={color} strokeWidth="2.5" />
      <circle cx="50" cy="42" r="3" fill={color} />

      {/* Objectif */}
      <rect x="45" y="75" width="10" height="8" fill={color} opacity="0.3" rx="1" />

      {/* Bras du microscope */}
      <path d="M 50 42 L 65 30 L 65 55" fill="none" stroke={color} strokeWidth="2.5" strokeLinecap="round" />

      {/* Lame porte-objet */}
      <rect x="40" y="73" width="20" height="2" fill={color} opacity="0.5" />
    </svg>
  );
}

// Doctorant - Chapeau de graduation avec livre
export function DoctorantIcon({ className = "w-12 h-12", color = "#D8B4FE" }: IconProps) {
  return (
    <svg viewBox="0 0 100 100" className={className} xmlns="http://www.w3.org/2000/svg">
      {/* Livre */}
      <rect x="30" y="50" width="40" height="30" fill={color} opacity="0.15" rx="2" />
      <rect x="30" y="50" width="40" height="30" fill="none" stroke={color} strokeWidth="2.5" rx="2" />

      {/* Pages du livre */}
      <line x1="50" y1="50" x2="50" y2="80" stroke={color} strokeWidth="2" />
      <line x1="40" y1="60" x2="45" y2="60" stroke={color} strokeWidth="1.5" opacity="0.5" />
      <line x1="40" y1="67" x2="45" y2="67" stroke={color} strokeWidth="1.5" opacity="0.5" />
      <line x1="55" y1="60" x2="60" y2="60" stroke={color} strokeWidth="1.5" opacity="0.5" />
      <line x1="55" y1="67" x2="60" y2="67" stroke={color} strokeWidth="1.5" opacity="0.5" />

      {/* Chapeau de graduation */}
      <path d="M 30 38 L 50 30 L 70 38 L 50 45 Z" fill={color} opacity="0.2" />
      <path d="M 30 38 L 50 30 L 70 38 L 50 45 Z" fill="none" stroke={color} strokeWidth="2.5" strokeLinejoin="round" />

      {/* Base du chapeau */}
      <rect x="42" y="37" width="16" height="3" fill={color} rx="1" />

      {/* Pompon */}
      <circle cx="70" cy="38" r="3" fill={color} />
      <line x1="70" y1="38" x2="75" y2="50" stroke={color} strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}

// Étudiant - Crayon avec cahier
export function EtudiantIcon({ className = "w-12 h-12", color = "#D8B4FE" }: IconProps) {
  return (
    <svg viewBox="0 0 100 100" className={className} xmlns="http://www.w3.org/2000/svg">
      {/* Cahier */}
      <rect x="25" y="35" width="35" height="45" fill={color} opacity="0.15" rx="2" />
      <rect x="25" y="35" width="35" height="45" fill="none" stroke={color} strokeWidth="2.5" rx="2" />

      {/* Spirale du cahier */}
      <circle cx="30" cy="42" r="2" fill="none" stroke={color} strokeWidth="1.5" />
      <circle cx="30" cy="50" r="2" fill="none" stroke={color} strokeWidth="1.5" />
      <circle cx="30" cy="58" r="2" fill="none" stroke={color} strokeWidth="1.5" />
      <circle cx="30" cy="66" r="2" fill="none" stroke={color} strokeWidth="1.5" />
      <circle cx="30" cy="74" r="2" fill="none" stroke={color} strokeWidth="1.5" />

      {/* Lignes sur le cahier */}
      <line x1="35" y1="45" x2="53" y2="45" stroke={color} strokeWidth="1.5" opacity="0.5" />
      <line x1="35" y1="52" x2="53" y2="52" stroke={color} strokeWidth="1.5" opacity="0.5" />
      <line x1="35" y1="59" x2="53" y2="59" stroke={color} strokeWidth="1.5" opacity="0.5" />
      <line x1="35" y1="66" x2="50" y2="66" stroke={color} strokeWidth="1.5" opacity="0.5" />

      {/* Crayon */}
      <rect x="50" y="50" width="8" height="30" fill={color} opacity="0.3" rx="1" transform="rotate(-30 54 65)" />
      <rect x="50" y="50" width="8" height="30" fill="none" stroke={color} strokeWidth="2.5" rx="1" transform="rotate(-30 54 65)" />

      {/* Pointe du crayon */}
      <path d="M 53 78 L 50 83 L 56 83 Z" fill={color} transform="rotate(-30 53 81)" />

      {/* Gomme */}
      <rect x="50" y="47" width="8" height="4" fill={color} opacity="0.5" rx="1" transform="rotate(-30 54 49)" />
    </svg>
  );
}

// Professeur - Tableau avec formule
export function ProfesseurIcon({ className = "w-12 h-12", color = "#D8B4FE" }: IconProps) {
  return (
    <svg viewBox="0 0 100 100" className={className} xmlns="http://www.w3.org/2000/svg">
      {/* Tableau */}
      <rect x="20" y="25" width="60" height="50" fill={color} opacity="0.15" rx="3" />
      <rect x="20" y="25" width="60" height="50" fill="none" stroke={color} strokeWidth="2.5" rx="3" />

      {/* Cadre du tableau */}
      <rect x="23" y="28" width="54" height="44" fill="none" stroke={color} strokeWidth="1.5" rx="2" />

      {/* Formule mathématique / Texte sur tableau */}
      <text x="35" y="45" fill={color} fontSize="14" fontWeight="bold">y = f(x)</text>
      <path d="M 30 52 Q 40 48, 50 52 T 70 52" fill="none" stroke={color} strokeWidth="2" />

      {/* Graphique simple */}
      <line x1="28" y1="65" x2="72" y2="65" stroke={color} strokeWidth="1.5" opacity="0.5" />
      <line x1="28" y1="65" x2="28" y2="58" stroke={color} strokeWidth="1.5" opacity="0.5" />
      <polyline points="28,65 35,62 45,60 55,63 65,58 72,60" fill="none" stroke={color} strokeWidth="2" />

      {/* Support du tableau */}
      <rect x="48" y="75" width="4" height="10" fill={color} opacity="0.3" />
    </svg>
  );
}
